import { Pipe, PipeTransform } from "@angular/core";
import { IOwner, isEntityOwner, isPersonOwner } from "../interfaces";

@Pipe({
  name: 'displayName',
})
export class DisplayNamePipe implements PipeTransform {
  transform(owner: IOwner): string {
    return isPersonOwner(owner)
      ? `${owner.firstName} ${owner.lastName}`
      : isEntityOwner(owner)
        ? owner.entityLegalName
        : "";
  }
}
